export default "/_next/static/images/MyDecor-cf58e928bd34164917cade5538c95c8f.png";